import React, { useState } from "react";
import { Button } from "primereact/button";
import { CreateGoalModal } from "./CreateGoalModal";

export interface EmptyStateProps {
  onCreate: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onCreate }) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return (
    <div className="goals-empty">
      <h2>No goals yet</h2>
      <p>
        Create your first funding goal to get personalized call recommendations.
      </p>
      <Button
        label="Create funding goal"
        icon="pi pi-plus"
        onClick={() => setIsCreateModalOpen(true)}
      />
      <CreateGoalModal
        visible={isCreateModalOpen}
        onHide={() => setIsCreateModalOpen(false)}
      />
    </div>
  );
};
